export const ImportActionType = {
  None: -99,
  AddNewUsers: 0,
  UpdateEmailSubscribersStatus: 1,
  UpdateSMSSubscribersStatus: 2,
  AddUpdateTags: 3,
  CustomMappings: 4,
};
